<template>
  <div
    v-if="!basic && action"
    :class="classList"
    @click.prevent="action"
    :data-id="id">
      <span>{{ title }}</span>
    <icon
      v-if="icon"
      :name="icon"
      class="float-right"
      height="14"></icon>
  </div>
  <router-link
    v-else-if="!basic && route && exact"
    :to="route"
    :class="classList"
    exact>
    <span class="a-list-item__icon">
      <icon
        v-if="listIcon"
        :name="listIcon"
        height="16"></icon>
    </span>
    <span>{{ title }}</span>
  </router-link>
  <router-link
    v-else-if="!basic && route && !exact"
    :to="route"
    :class="classList">
      <span class="a-list-item__icon">
        <icon :name="listIcon" v-if="listIcon" height="16"></icon>
      </span>
      <span>{{ title }}</span>
  </router-link>
  <router-link
    v-else-if="basic && route"
    :class="classList"
    @click.prevent="action"
    :to="route"
    :data-id="id">
      <span>{{ title }}</span>
  </router-link>
  <div
    v-else-if="basic && action"
    :class="classList"
    @click.prevent="action"
    :data-id="id">
      <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'v-list-item',
  props: {
    title: {
      type: [String],
      required: true,
    },
    active: {
      type: [Boolean],
      default: false,
    },
    basic: {
      type: [Boolean],
      default: false,
    },
    selectFirst: {
      type: [Boolean],
      default: false,
    },
    exact: {
      type: [Boolean],
      default: false,
    },
    listIcon: {
      type: [String, Boolean],
      default: false,
    },
    inverted: {
      type: [Boolean],
      default: false,
    },
    action: [Function],
    route: [String],
    icon: [String],
    id: [Number],
  },
  data() {
    return {
      selected: false,
    };
  },
  computed: {
    classList() {
      const {
        active, basic, selected, inverted,
      } = this;
      return {
        'a-list-item': true,
        'a-list-item--active': active,
        'a-list-item--basic': basic,
        'a-list-item--selected': selected,
        'a-list-item--inverted': inverted,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.a-list-item';

  $list-odd-color: lighten($signable-secondary-2, 5%);

  #{$parent} {
    color: initial;
    padding: $spacing-base;
    display: block;
    text-decoration: none;
    font-weight: bold;
    border-left: 0px solid $signable-secondary-2-shade-3;
    transition: 0.2s border-left ease;
    &--inverted {
      color: #fff;
      background: $signable-secondary-2;
      border-bottom: 1px solid $list-odd-color;
      @include clearfix;
      span:not(#{$parent}__icon) {
        float: left;
        margin-top: 3px;
      }
      #{$parent}__icon {
        padding: $spacing-xs;
        background: #fff;
        border-radius: 30px;
        position: relative;
        height: 26px;
        width: 26px;
        float: left;
        margin-right: $spacing-small;
        svg {
          @include alignElement(true, true);
          margin: 0;
          fill: $signable-secondary-2-shade-2;
          width: 12px;
        }
      }
      &--active,
      &.router-link-active {
        border-left: 6px solid $signable-secondary-2-shade-3;
        background: $list-odd-color;
        color: #fff;
        border-bottom: 0;
        #{$parent}__icon {
          background: #fff;
          svg {
            fill: $signable-secondary-1;
          }
        }
      }
    }
    &--basic {
      padding: $spacing-small;
      cursor: pointer;
      border-top: 1px solid $color-border;
      background: #fff;
      font-weight: normal;
      &:nth-of-type(odd) {
        background: #fff;
      }
      &:hover {
        background-color: $signable-secondary-3-shade-3;
      }
      &:first-child {
        border-top: 0;
      }
      &#{$parent}--selected {
        background-color: $signable-secondary-2-shade-3;
        color: #fff;
        font-weight: 600;
      }
    }
    svg {
      vertical-align: text-top;
      margin-right: $spacing-xs;
      width: 20px;
    }
  }
</style>
